module.exports = __webpack_public_path__ + "img/ch4.35418c6c.jpg";